module.exports = __webpack_public_path__ + "static/img/IMG_20170304_200728.3cf62b1d.jpg";